module.exports = __webpack_public_path__ + "img/vendor_logo9.a739b248.png";